export function getCookie(name) {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      const cookieValue = cookie.substring(`${name}=`.length);
      return decodeURIComponent(cookieValue);
    }
  }
  return ""; // Return a default value if the cookie is not found
}
